import { render } from "./recruitinfo-count.vue?vue&type=template&id=912f72fe&scoped=true"
import script from "./recruitinfo-count.vue?vue&type=script&lang=js"
export * from "./recruitinfo-count.vue?vue&type=script&lang=js"

import "./recruitinfo-count.vue?vue&type=style&index=0&id=912f72fe&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-912f72fe"]])

export default __exports__